<template>
    <div
        class="relative flex cursor-pointer flex-col rounded-lg transition hover:font-bold hover:ring-4 hover:ring-grind"
        :class="
            showError
                ? 'ring-2 ring-error'
                : selected
                  ? 'ring-4 ring-grind'
                  : 'ring-1 ring-grind-200'
        "
        @click="optionSelected"
    >
        <div
            v-if="selected"
            class="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-grind text-xs text-white"
        >
            <Icon name="check" class="text-base" />
        </div>
        <div
            class="flex h-40 w-full items-center justify-center overflow-hidden rounded-t-lg border-b border-grind-200 bg-white"
            :class="optionData?.isBackgroundImg ? '' : 'py-2'"
        >
            <img
                v-if="optionData.img"
                :src="optionData.img.src"
                :alt="optionData.img.alt ?? 'Card Background Image'"
                :class="[
                    isTooShort
                        ? 'h-full w-auto object-cover'
                        : 'max-h-full max-w-full object-contain',
                ]"
                @load="handleImageLoad"
            />
            <div v-else class="h-full w-full bg-grind-100"></div>
        </div>
        <div class="flex flex-col gap-3 py-3">
            <div
                v-if="optionData?.topText"
                class="px-3 text-left leading-none tracking-wide text-grind"
                :class="{
                    'font-bold': selected,
                }"
            >
                {{ optionData.topText }}
            </div>
            <div
                v-if="optionData?.middleText"
                class="px-3 text-left text-sm leading-5 tracking-wide text-grind-800 lg:leading-none"
                :class="{
                    'font-bold': selected,
                }"
            >
                {{ optionData.middleText }}
            </div>
            <div
                v-if="optionData?.bottomText"
                class="px-3 text-left text-sm tracking-wide text-grind"
                :class="{
                    'font-bold': selected,
                }"
            >
                {{ optionData.bottomText }}
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import type { OptionsCardType } from '#shared/types/design-lab/OptionsCardType';
import Icon from '~/components/Icon.vue';

const props = withDefaults(
    defineProps<{
        showError?: boolean;
        selected: boolean;
        optionData: OptionsCardType | null;
    }>(),
    {
        error: false,
        selected: true,
        optionData: null,
    },
);

const isTooShort = ref(false);

/**
 * Ensure the loaded image fills the entire height
 * @param event
 */
function handleImageLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    // 160px = h-40
    if (img.clientHeight < 160) {
        isTooShort.value = true;
    }
}

function optionSelected(): void {
    emit('selectOption', props.optionData.value);
}

const emit = defineEmits<{ (e: 'selectOption', value: number): void }>();
</script>
